import { post } from "../../common/api/apiShared";
import { useOptimisticUpdate } from "../../common/hooks/useOptimisticUpdate";
import { useDotLegalQuery, useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useCreateCommentDataMapping(getSubscriptionUrl: string, setSubscriptionUrl: string, disabled?: boolean) {
    const { putOnQueueAndSetQueryData } = useOptimisticUpdate();

    const url = getSubscriptionUrl;
    const { isLoading, data } = useDotLegalQuery<boolean>(url, {
        enabled: !disabled,
    });

    const onSubscriptionChange = async (subscribe: boolean) => {
        putOnQueueAndSetQueryData(subscribe, url, saveSubscriptionMutation.mutateAsync, subscribe);
    };

    const saveSubscriptionMutation = useDotLegalMutation(updateSubscription);

    function updateSubscription(subscribe: boolean) {
        return post<{}>(setSubscriptionUrl, subscribe);
    }

    return {
        isLoading,
        subscribed: data,
        onSubscriptionChange,
        subscriptionSaving: saveSubscriptionMutation.isLoading,
    };
}
